import { MentionProps } from 'stream-chat-react';

// Based on the default Mention component
// https://github.com/GetStream/stream-chat-react/blob/master/src/components/Message/renderText/componentRenderers/Mention.tsx
export const CustomMentionComponent = ({
  children,
  node: { mentionedUser },
}: MentionProps) => (
  <span className="text-gray-small" data-user-id={mentionedUser.id}>
    {children}
  </span>
);
